export const COURSE_TYPES = [
  { value: 'live_online', label: 'Live online tutoring', description: 'Real-time virtual coaching and lessons.' },
  { value: 'in_person', label: 'In-person classes', description: 'Physical classes at your location or campus.' },
  { value: 'hybrid', label: 'Hybrid learning', description: 'A mix of physical and virtual learning.' },
  { value: 'self_paced', label: 'Self-paced digital course', description: 'An LMS course with videos, audio, PDFs and independent study.' },
];

export function getCourseTypeLabel(value) {
  return COURSE_TYPES.find((type) => type.value === value)?.label || 'Course type not set';
}
